module.exports = __webpack_public_path__ + "static/media/perc.79d424e9.ogg";